import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { AuthContext } from '../../contexts/AuthContext';
import { ADMIN_PATH, MAPS_PATH } from '../../api/companySession';

const AuthenticatedRoute = ({ children, platformAdminOnly = false }) => {
    const {
        isAuthenticated,
        isAuthReady,
        isPlatformSupervisor,
        isInCompanyContext,
    } = useContext(AuthContext);

    if (!isAuthReady) {
        return (
            <div className="auth-route-loading">
                <Spin size="large" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (platformAdminOnly && !isPlatformSupervisor) {
        return <Navigate to={MAPS_PATH} replace />;
    }

    if (!platformAdminOnly && isPlatformSupervisor && !isInCompanyContext) {
        return <Navigate to={ADMIN_PATH} replace />;
    }

    return children;
};

export default AuthenticatedRoute;
